"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVehicleCharging = function IconVehicleCharging(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M25.105 6.709 23.247 8.56l1.338 1.34L26.4 8.084l1.413 1.414-1.816 1.816 1.404 1.406-2.521 2.525a5 5 0 0 1-3.531 1.464 5 5 0 0 1-2.417-.63A2.64 2.64 0 0 0 19.27 19l.143.154 4.135 4.14-.01.01a3.91 3.91 0 0 1 .001 5.533 3.904 3.904 0 0 1-5.368.153l-.161-.153-4.028-4.033v18.198h-1.997V16a3 3 0 0 0-2.82-2.996L8.989 13H4.994v-2H8.99a4.996 4.996 0 0 1 4.988 4.783l.005.217v5.975l5.44 5.448-.413.415.415-.415a1.907 1.907 0 0 0 2.702 0 1.913 1.913 0 0 0 .114-2.58l-.114-.125.975-.977-.965.966L18 20.568a4.645 4.645 0 0 1-.61-5.81 5.005 5.005 0 0 1 .426-6.583L20.34 5.65l1.495 1.497 1.861-1.854zM33.94 26.83l8.591 1.37a3.1 3.1 0 0 1 1.924 1.107l.126.166c.443.627.637 1.395.548 2.153l-.031.206-.86 4.627a3.1 3.1 0 0 1-2.864 2.535l-.186.005h-3.336a5 5 0 0 1-4.893 4 5 5 0 0 1-4.894-4H16.98v-2h11.086a5 5 0 0 1 4.894-4 5 5 0 0 1 4.893 4h3.34a1.1 1.1 0 0 0 1.054-.785l.028-.118.86-4.63a1.1 1.1 0 0 0-.79-1.262l-.124-.028-9.205-1.468-8.505-8.115 1.378-1.448zM32.96 35a3 3 0 0 0 0 6 3 3 0 0 0 2.996-3c0-1.657-1.341-3-2.996-3m0 1.5a1.499 1.499 0 1 1-.002 2.997 1.499 1.499 0 0 1 .002-2.997m0 1a.5.5 0 1 0 0 .998.5.5 0 0 0 0-.998m-7.99-1.5h-3.995v-1h3.995zM6.127 26l3-.5-5 8.5 1-6-3 .5 5-8.5zM19.23 9.588c-1.17 1.172-1.17 3.07-.021 4.222l.143.137a2.995 2.995 0 0 0 4.115-.116l1.107-1.11-4.237-4.244z"
  })));
};

export { IconVehicleCharging, IconVehicleCharging as default };
